/* eslint-disable react/prop-types */
import { Label, Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react'
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { useEffect, useState } from 'react'
import _ from 'lodash'
export default function Select({
    label,
    value,
    onChange,
    options,
    isFlatArray = false,
    tKey = 'name',
    tId = '_id',
    hasIcon = false,
    disabledItems = [],
}) {
    if (value && _.isArray(value) && value.length > 0) {
        value = value[0]
    }
    if (options.length === 0) {
        return null
    }
    const removeValue = (e) => {
        e.stopPropagation()
        onChange(null)
    }
    
    const v = value ? (isFlatArray ? value : value[tKey]) : ''
    const imgSrc1 = value && value.icon && typeof value.icon === 'string' && value.icon.startsWith('http')
    return (
        <Listbox value={value} onChange={onChange}>
            <Label className='block text-sm font-medium leading-6 text-gray-900'>{label}</Label>
            <div className='relative '>
                <ListboxButton className='min-h-9 relative w-full cursor-default rounded-md bg-white py-1.5 pl-1 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-1 focus:ring-indigo-600 sm:text-sm sm:leading-6'>
                <span className="col-start-1 row-start-1 flex items-center gap-1 pr-6">
                    {imgSrc1 ? <img alt='' src={value?.icon} className='h-5 w-5 flex-shrink-0 rounded-full' /> :
                    value && value?.icon ? <value.icon className="size-2 shrink-0 rounded-full text-gray-400 font-normal" />: null }
                    <span className='block truncate '>{v ?? 'Select'}</span>

                    <span className='absolute inset-y-0 right-0 flex items-center pr-2 z-0'>
                        {v ? (
                            <XMarkIcon aria-hidden='true' className='h-5 w-5 text-gray-400 cursor-pointer ' onClick={removeValue} />
                        ) : (
                            <ChevronUpDownIcon aria-hidden='true' className='h-5 w-5 text-gray-400 z-0' />
                        )}
                    </span>
                    </span>
                </ListboxButton>

                <ListboxOptions
                    transition
                    className='absolute z-20 mt-1 max-h-60 min-h-12 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in sm:text-sm items-start'
                >
                    {options
                        .filter((p) => !disabledItems.includes(p[tKey] ?? p))
                        .map((person) => {
                            const imgSrc = person && person.icon && typeof person.icon === 'string' && person.icon.startsWith('http')
                            return(
                            <ListboxOption
                                key={isFlatArray ? person : person[tId]}
                                value={person}
                                className=' items-start group relative cursor-default select-none py-2 pl-1 pr-4 text-gray-900 data-[focus]:bg-gray-300 data-[focus]:text-white'
                            >
                                <div className="flex items-center">
                                    {imgSrc ? <img alt='' src={person.icon} className='h-5 w-5 flex-shrink-0 rounded-full' /> :
                                person && person.icon ? <person.icon className="size-2 shrink-0 rounded-ful mr-1 text-gray-400 font-normal " />: null }
                                <span className='text-left block truncate font-normal group-data-[selected]:font-semibold'>
                                    {isFlatArray ? person : person[tKey]}
                                </span>
                                </div>

                                <span className='absolute inset-y-0 right-0 flex items-center pr-1.5 text-gray-700 group-data-[focus]:text-white [.group:not([data-selected])_&]:hidden'>
                                    <CheckIcon aria-hidden='true' className='h-5 w-5' />
                                </span>
                            </ListboxOption>
                        )})}
                </ListboxOptions>
            </div>
        </Listbox>
    )
}

export function SelectWithIcon({ value, options = [], onSelect, label }) {
    const [selected, setSelected] = useState(null)
    useEffect(() => {
        if (value) {
            setSelected(value)
        }
    }, [value])
    const handleSelect = (person) => {
        setSelected(person)
        onSelect(person)
    }
    if (!options) return null
    if (!_.isArray(options)) return null
    return (
        <Listbox value={selected} onChange={handleSelect}>
            <Label className='block text-sm font-normal leading-6 text-gray-900'>{label}</Label>
            <div className='relative mt-2'>
                <ListboxButton className='relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500 sm:text-sm sm:leading-6 min-h-9'>
                    <span className='flex items-center'>
                        {selected?.imageUrl ? <img alt='' src={selected.avatar} className='h-5 w-5 flex-shrink-0 rounded-full' /> : null}
                        {selected?.name ? <span className='ml-3 block truncate'>{selected.name}</span> : null}
                    </span>
                    <span className='pointer-events-none absolute inset-y-0 right-0 ml-3 flex items-center pr-2'>
                        <ChevronUpDownIcon aria-hidden='true' className='h-5 w-5 text-gray-400' />
                    </span>
                </ListboxButton>

                <ListboxOptions
                    transition
                    className='absolute z-30 mt-1 max-h-56 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in sm:text-sm'
                >
                    {options.map((option) => (
                        <ListboxOption
                            key={option._id}
                            value={option}
                            className='group relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 data-[focus]:bg-indigo-600 data-[focus]:text-white'
                        >
                            <div className='flex items-center'>
                                {option.imageUrl ? <img alt='' src={option.icon} className='h-5 w-5 flex-shrink-0 rounded-full' /> : null}
                                <span className='ml-3 block truncate font-normal group-data-[selected]:font-semibold'>{option.name}</span>
                            </div>

                            <span className='absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600 group-data-[focus]:text-white [.group:not([data-selected])_&]:hidden'>
                                <CheckIcon aria-hidden='true' className='h-5 w-5' />
                            </span>
                        </ListboxOption>
                    ))}
                </ListboxOptions>
            </div>
        </Listbox>
    )
}
